document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.add-to-cart-form').forEach(form => {

		const button = form.querySelector('button');
		const originalText = button.textContent;

		form.addEventListener('submit', async (e) => {
			e.preventDefault();

			const productId = form.querySelector('input[name="add-to-cart-button-id"]').value;

			try {
				await fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				body: JSON.stringify({ id: productId, quantity: 1 })
				});

				//console.info('Hinzufügen zum Warenkorb:', JSON.stringify({ id: productId, quantity: 1 }));

				// Button Text kurzfristig ändern
				button.textContent = '✔ Hinzugefügt!';
				setTimeout(() => { button.textContent = originalText; }, 2000);

				// Update cart count
				window.location.reload()

			} catch (error) {
				console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
				button.textContent = 'Fehler! ✖';
				setTimeout(() => { button.textContent = originalText; }, 2000);
			}
		});
	});
});